import React from "react";
import { useCallbackRef } from "../../../hooks/useCallbackRef";
import FilterSingleValue from "../../filters/FilterSingleValue";

function BaseFilter({ onSearchChange, ...props }) {
  const onSearch = useCallbackRef(onSearchChange);
  const handleSearch = React.useCallback(
    (search) => {
      onSearch({ search });
    },
    [onSearch],
  );

  return (
    <FilterSingleValue
      placeholder="Search for base"
      onSearchChange={handleSearch}
      multiple
      noAll
      {...props}
    />
  );
}

export default BaseFilter;
